{
  "buttons": {
    "save": "保存",
    "cancel": "取消",
    "continue": "继续",
    "back": "返回",
    "submit": "提交",
    "delete": "删除",
    "edit": "编辑",
    "close": "关闭",
    "confirm": "确认",
    "next": "下一步",
    "previous": "上一步",
    "upload": "上传",
    "download": "下载",
    "refresh": "刷新",
    "retry": "重试",
    "learnMore": "了解更多",
    "getStarted": "开始使用",
    "viewDetails": "查看详情",
    "saveChanges": "保存更改"
  },
  "labels": {
    "email": "电子邮件",
    "name": "姓名",
    "firstName": "名",
    "lastName": "姓",
    "phone": "电话",
    "company": "公司",
    "companyName": "公司名称",
    "country": "国家",
    "address": "地址",
    "city": "城市",
    "state": "省份",
    "postcode": "邮编",
    "website": "网站",
    "description": "描述",
    "date": "日期",
    "status": "状态",
    "actions": "操作",
    "type": "类型",
    "category": "类别",
    "notes": "备注"
  },
  "status": {
    "loading": "加载中...",
    "saving": "保存中...",
    "success": "成功！",
    "error": "发生错误",
    "pending": "待处理",
    "completed": "已完成",
    "inProgress": "进行中",
    "draft": "草稿",
    "active": "活跃",
    "inactive": "非活跃"
  },
  "validation": {
    "required": "此字段为必填项",
    "invalidEmail": "请输入有效的电子邮件地址",
    "minLength": "至少需要{{min}}个字符",
    "maxLength": "不能超过{{max}}个字符",
    "invalidPhone": "请输入有效的电话号码",
    "invalidUrl": "请输入有效的网址"
  },
  "errors": {
    "generic": "出现问题，请重试。",
    "network": "网络错误，请检查您的连接。",
    "unauthorized": "您无权执行此操作。",
    "notFound": "未找到请求的资源。",
    "serverError": "服务器错误，请稍后重试。"
  },
  "navigation": {
    "home": "首页",
    "dashboard": "控制面板",
    "settings": "设置",
    "profile": "个人资料",
    "logout": "退出登录",
    "login": "登录",
    "signUp": "注册",
    "help": "帮助",
    "support": "支持"
  },
  "time": {
    "today": "今天",
    "yesterday": "昨天",
    "lastWeek": "上周",
    "lastMonth": "上月",
    "ago": "前",
    "minutes": "分钟",
    "hours": "小时",
    "days": "天"
  },
  "language": {
    "select": "选择语言",
    "en": "English",
    "es": "Español",
    "de": "Deutsch",
    "zh": "中文"
  }
}
